// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a9dbbb8b","453":"36f99971","634":"67d81333","667":"1298fcb6"}[chunkId] + ".chunk.js";
};